import Glide from '@glidejs/glide';
import { getElements, ifSelectorExist } from './utils';

export const heritageSliders = () => {

  const textReviewsBlockSlider = getElements('.reviews_heritage_block__slider');
  if (ifSelectorExist(textReviewsBlockSlider)) {
    Array.from(textReviewsBlockSlider).forEach(item => {
      const glide = new Glide(item, {
        type: 'carousel',
        gap: 0,
        perView: 3,
        autoplay: 5000,
        breakpoints: {
          1024: {
            perView: 2,
          },
          768: {
            perView: 1,
          },
        },
      });
      glide.mount();
    });
  }

  const coupons_heritage_slider = '.coupons_heritage_slider';
  if (ifSelectorExist(coupons_heritage_slider)) {
    Array.from(getElements(coupons_heritage_slider)).forEach(item => {
      new Glide(item, {
        perView: 1,
        type: 'carousel',
        animationDuration: 300,
        // autoplay: 4000,
      }).mount();
    });
  }

  const coupons_blaze_sidebar_slider = '.coupons_heritage_sidebar_slider';
  if (ifSelectorExist(coupons_blaze_sidebar_slider)) {
    Array.from(getElements(coupons_blaze_sidebar_slider)).forEach(item => {
      new Glide(item, {
        perView: 1,
        type: 'carousel',
      }).mount();
    });
  }
};
